export enum ExpandableTextTags {
   ExpandableText = 'atlantis-expandable-text',
}
